import { render, staticRenderFns } from "./carInstitutionList.vue?vue&type=template&id=64866322&scoped=true"
import script from "./carInstitutionList.vue?vue&type=script&lang=js"
export * from "./carInstitutionList.vue?vue&type=script&lang=js"
import style0 from "./carInstitutionList.vue?vue&type=style&index=0&id=64866322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64866322",
  null
  
)

export default component.exports